var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/sms.68b3862d.png","uri@3x": __webpack_public_path__ + "static/media/sms.177d46ea.png","uri@2x": __webpack_public_path__ + "static/media/sms.4634b8f5.png",
    width: 48,
    height: 48
});